import * as S from '@/styles/pages/ForgotPassword';
import Head from 'next/head';
import Image from 'next/future/image';
import { BsChevronLeft } from 'react-icons/bs';
import Link from 'next/link';

import { MdOutlineEmail } from 'react-icons/md';
import { FormEvent, useCallback, useState } from 'react';

import { Auth } from 'aws-amplify';
import { ModalForgotPassword } from '@/components/pages/ForgotPassword';

export default function ForgotPassword() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event?.preventDefault();
    setIsLoading(true);
    if (email.length) {
      await Auth.forgotPassword(email);
      setOpenModal(true);
    }
    setIsLoading(false);
  }

  return (
    <S.Container>
      {openModal && (
        <ModalForgotPassword onClose={handleCloseModal} email={email} />
      )}
      <Head>
        <title>Nextou - Esqueci Minha Senha</title>
      </Head>
      <S.Wrapper>
        <S.NextouContainer>
          <Image
            alt="Logo"
            src="/logo.svg"
            width={137}
            height={43.93}
            id="logo"
          />
          <Image
            width={553}
            height={557}
            src="/nextouLogin.svg"
            alt="Nextou"
            id="nextou"
          />

          <p>
            Faça com que o aprendizado fique ao alcance de todos. Comece agora
            mesmo!
          </p>
        </S.NextouContainer>
        <S.ForgotPasswordContainer>
          <S.ForgotPasswordWrapper>
            <S.ForgotPasswordHeader>
              <Link prefetch={false} href="/" passHref>
                <a>
                  <BsChevronLeft color="#fff" size={40} />
                </a>
              </Link>
              <Image
                src="/purpleNextou.svg"
                alt="Nestor"
                width={137}
                height={43.93}
              />
            </S.ForgotPasswordHeader>
            <strong>Esqueceu sua senha?</strong>
            <p>Não se preocupe, recupere sua conta!</p>
            <S.ForgotPasswordForm onSubmit={handleSubmit}>
              <div>
                <MdOutlineEmail color="#fff" size={30} />
                <input
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  type="email"
                  disabled={isLoading}
                  placeholder="Digite seu email"
                />
              </div>
              <button type="submit" disabled={isLoading || !email.length}>
                Enviar
              </button>
            </S.ForgotPasswordForm>
          </S.ForgotPasswordWrapper>
        </S.ForgotPasswordContainer>
      </S.Wrapper>
    </S.Container>
  );
}
